export default class ParameterOperational {
    constructor() {
        this.showReturnWithoutOutput = false
    }
    update(data) {
      this.showReturnWithoutOutput = data.showReturnWithoutOutput;
    }
}